import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  signInWithEmailAndPassword,
  browserLocalPersistence,
} from 'firebase/auth';

import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAyfpz7I_KaI4PTW0NDhKtwQ9CiLAbyi1U',
  authDomain: 'xtvultra.firebaseapp.com',
  projectId: 'xtvultra',
  storageBucket: 'xtvultra.appspot.com',
  messagingSenderId: '611680964330',
  appId: '1:611680964330:web:31670e35ada49f2e6dd193',
  measurementId: 'G-CNQ9Q29RSK',
};

// const firebaseConfig = {
//   apiKey: 'AIzaSyD8VRdPBpvKczdNS2cr_HTHK_2K7JMUbu4',
//   authDomain: 'xtvultra-dev.firebaseapp.com',
//   projectId: 'xtvultra-dev',
//   storageBucket: 'xtvultra-dev.firebasestorage.app',
//   messagingSenderId: '356046460591',
//   appId: '1:356046460591:web:a9ada8fc77270f6c31265a',
// };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// setPersistence(auth, browserLocalPersistence)
//   .then(() => {
//     return signInWithEmailAndPassword(auth, email, password);
//   })
//   .catch((error) => {
//     console.log(error);
//   });

// export default app;
